import * as tslib_1 from "tslib";
import { autocompleteGhostText, setSelectedSuggestionIndex } from '../actions/internalActions';
import { onSearchTextChanged } from '../actions/publicActions';
import isGhostTextVisible from '../selectors/isGhostTextVisible';
import { defaultSearchStore, getStore } from '../store/store';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { lazyOnBackspacePressedSearchInput, lazyOnDownArrowPressedSearchInput, lazyOnEnterPressedSearchInput, lazyOnSearchInputFocused, lazyOnUpArrowPressedSearchInput, lazySetIsFocusInSearchInput, } from 'owa-search';
var styles = require('./SearchInput.scss');
var SearchInput = /** @class */ (function (_super) {
    tslib_1.__extends(SearchInput, _super);
    function SearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Key handler for special key input into the input element.
         */
        _this.onKeyDown = function (evt) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var evtKeyCode, _a, onEnterPressedSearchInput, onBackspacePressedSearchInput, onUpArrowPressedSearchInput, onDownArrowPressedSearchInput;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        evt.stopPropagation();
                        evtKeyCode = evt.keyCode;
                        _a = evtKeyCode;
                        switch (_a) {
                            case 13 /* Enter */: return [3 /*break*/, 1];
                            case 8 /* Backspace */: return [3 /*break*/, 3];
                            case 38 /* Up_arrow */: return [3 /*break*/, 5];
                            case 40 /* Down_arrow */: return [3 /*break*/, 7];
                            case 39 /* Right_arrow */: return [3 /*break*/, 9];
                            case 9 /* Tab */: return [3 /*break*/, 10];
                            case 35 /* End */: return [3 /*break*/, 11];
                            case 36 /* Home */: return [3 /*break*/, 11];
                            case 37 /* Left_arrow */: return [3 /*break*/, 11];
                            case 34 /* Page_down */: return [3 /*break*/, 11];
                            case 33 /* Page_up */: return [3 /*break*/, 11];
                        }
                        return [3 /*break*/, 12];
                    case 1: return [4 /*yield*/, lazyOnEnterPressedSearchInput.import()];
                    case 2:
                        onEnterPressedSearchInput = _b.sent();
                        onEnterPressedSearchInput(getStore().selectedSuggestionIndex);
                        return [3 /*break*/, 13];
                    case 3: return [4 /*yield*/, lazyOnBackspacePressedSearchInput.import()];
                    case 4:
                        onBackspacePressedSearchInput = _b.sent();
                        onBackspacePressedSearchInput();
                        return [3 /*break*/, 13];
                    case 5:
                        // Prevents cursor from going to beginning of input.
                        evt.preventDefault();
                        return [4 /*yield*/, lazyOnUpArrowPressedSearchInput.import()];
                    case 6:
                        onUpArrowPressedSearchInput = _b.sent();
                        onUpArrowPressedSearchInput();
                        return [3 /*break*/, 13];
                    case 7: return [4 /*yield*/, lazyOnDownArrowPressedSearchInput.import()];
                    case 8:
                        onDownArrowPressedSearchInput = _b.sent();
                        onDownArrowPressedSearchInput();
                        return [3 /*break*/, 13];
                    case 9:
                        {
                            this.onAutocompleteGhostText('rightArrow');
                            return [3 /*break*/, 13];
                        }
                        _b.label = 10;
                    case 10:
                        {
                            /**
                             * Prevents focus from shifting to search button if there is
                             * ghost text visible.
                             */
                            if (isGhostTextVisible()) {
                                evt.preventDefault();
                            }
                            this.onAutocompleteGhostText('tab');
                            return [3 /*break*/, 13];
                        }
                        _b.label = 11;
                    case 11:
                        {
                            return [3 /*break*/, 13];
                        }
                        _b.label = 12;
                    case 12:
                        /**
                         * Clears the selected suggestion (keyboard selection) if there
                         * is one, and if user didn't press a navigation key.
                         */
                        if (getStore().selectedSuggestionIndex !==
                            defaultSearchStore.selectedSuggestionIndex) {
                            setSelectedSuggestionIndex(defaultSearchStore.selectedSuggestionIndex);
                        }
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Handler when a key responsible for ghost text autocompletion (TAB or
         * right arrow) is keyed.
         */
        _this.onAutocompleteGhostText = function (keyUsed) {
            // Get cursor position.
            var isTextSelected = _this.searchInput.selectionStart !== _this.searchInput.selectionEnd;
            var cursorPosition = isTextSelected ? -1 : _this.searchInput.selectionStart;
            // Dispatch action to autocomplete ghost text.
            autocompleteGhostText(cursorPosition, keyUsed);
        };
        /**
         * Click handler when user clicks in input.
         */
        _this.onClick = function (evt) {
            evt.stopPropagation();
            lazySetIsFocusInSearchInput.importAndExecute(true /* isFocusInSearchInput */);
        };
        /**
         * Focus handler for when the SearchInput component receives focus.
         */
        _this.onFocus = function (evt) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var onSearchInputFocused;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lazyOnSearchInputFocused.import()];
                    case 1:
                        onSearchInputFocused = _a.sent();
                        onSearchInputFocused();
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Focus handler for when the SearchInput component loses focus.
         */
        _this.onBlur = function (evt) {
            lazySetIsFocusInSearchInput.importAndExecute(false /* isFocusInSearchInput */);
            _this.props.onBlur(evt);
        };
        /**
         * Need to do this synchronously or there'll be rendering issues and the value
         * of the input element will be empty.
         */
        _this.onSearchTextChange = function () {
            onSearchTextChanged(_this.searchInput.value);
        };
        return _this;
    }
    /**
     * Sets focus on the search input. This is exposed publicly so parent component
     * (SearchBox) can set focus on the input element as a result of clicks on other
     * parts of the search box.
     */
    SearchInput.prototype.setFocus = function () {
        this.searchInput.focus();
    };
    SearchInput.prototype.render = function () {
        var _this = this;
        var searchStore = getStore();
        /**
         * Show placeholder text when:
         * - There's no search text AND
         * - There are no pills
         */
        var shouldShowPlaceholder = searchStore.searchText == '' && searchStore.suggestionPillIds.length == 0;
        /**
         * Show ghost text when:
         * - There's ghost text to show AND
         * - Focus is in the search input
         */
        var showGhostText = searchStore.ghostText && searchStore.isFocusInSearchInput;
        return (React.createElement("div", { className: styles.searchBoxInputContainer },
            React.createElement("input", { "aria-label": strings.SearchPlaceholder, className: styles.searchBoxInput, onBlur: this.onBlur, onChange: this.onSearchTextChange, onClick: this.onClick, onFocus: this.onFocus, onKeyDown: this.onKeyDown, placeholder: shouldShowPlaceholder ? strings.SearchPlaceholder : '', ref: function (ref) { return (_this.searchInput = ref); }, value: searchStore.searchText }),
            showGhostText && (React.createElement("input", { className: styles.ghostTextInput, disabled: true, value: searchStore.ghostText }))));
    };
    SearchInput = tslib_1.__decorate([
        observer
    ], SearchInput);
    return SearchInput;
}(React.Component));
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map